export const pageBodyContainer = "galleryCss_pageBodyContainer";
export const pageContentContainer = "galleryCss_pageContentContainer";
export const pageContentContainerAnimation = "galleryCss_pageContentContainerAnimation";
export const pageSquareBtn = "galleryCss_pageSquareBtn";
export const pageSquareImg = "galleryCss_pageSquareImg";
export const sliderContainer = "galleryCss_sliderContainer";
export const sliderImageTransAnim = "galleryCss_sliderImageTransAnim";
export const sliderImageTrans = "galleryCss_sliderImageTrans";
export const sliderImage = "galleryCss_sliderImage";
export const sliderImageFullMode = "galleryCss_sliderImageFullMode";
export const sliderImageContainer = "galleryCss_sliderImageContainer";
export const fvHead = "galleryCss_fvHead";
export const fvBodyContainer = "galleryCss_fvBodyContainer";
export const fvBackBtn = "galleryCss_fvBackBtn";
export const fvTitle = "galleryCss_fvTitle";
export const fvRight = "galleryCss_fvRight";
export const fvArrow = "galleryCss_fvArrow";
export const fvArrowBtn = "galleryCss_fvArrowBtn";
export const fvBody = "galleryCss_fvBody";
export const fvImageContainer = "galleryCss_fvImageContainer";
export const fvSides = "galleryCss_fvSides";
export const fvSidesLeft = "galleryCss_fvSidesLeft";
export const fvSidesRight = "galleryCss_fvSidesRight";
